import angular from 'angular';
import { normalizeIncludeInReports, toEventPayload } from 'application/util/event-report.util';

const UNSET_HEADER = (() => {})();

export default class EventService {
    /* @ngInject */
    constructor($q, eventUtil, apiService, sessionService) {
        this.$q = $q;
        this.eventUtil = eventUtil;
        this.apiService = apiService;
        this.sessionService = sessionService;
    }

    getInitial(timestamp) {
        return this.$q((resolve) => {
            let event = {
                timestamp,
                confirmed: this.eventUtil.isPast(timestamp),
                isIncludedInReports: true,
                owner: angular.merge({}, this.sessionService.user)
            };

            resolve(event);
        });
    }

    create(calendarId, event) {
        return this.apiService.post(`/calendars/${calendarId}/transactions`, toEventPayload(event)).then((result) => normalizeIncludeInReports(result.data));
    }

    uploadReceipt(file, filename = 'receipt.jpeg') {
        const formData = new FormData();
        formData.append('receipt', file, filename);

        return this.apiService.post(`/upload/receipt`, formData, {
            transformRequest: (data) => data,
            headers: {
                'Content-Type': UNSET_HEADER
            }
        }).then((result) => {
            const data = result && result.data ? result.data : {};
            return data.url || null;
        });
    }

    update(event, eventSelector) {
        return this.apiService.put(`/transactions/${event.id}`, toEventPayload(event), {
            params: {
                which: eventSelector || this.eventUtil.EventRepeatSelector.OnlyThis
            }
        }).then((result) => normalizeIncludeInReports(result.data));
    }

    updateRepeating(event, occurrence, eventSelector) {
        return this.apiService.post(`/transactions/${event.templateId}/${occurrence}`, toEventPayload(event), {
            params: {
                which: eventSelector || this.eventUtil.EventRepeatSelector.OnlyThis
            }
        }).then((result) => normalizeIncludeInReports(result.data));
    }

    remove(event, eventSelector) {
        return this.apiService.delete(`/transactions/${event.id}`, {
            params: {
                which: eventSelector || this.eventUtil.EventRepeatSelector.OnlyThis
            }
        });
    }

    removeRepeating(event, occurrence, eventSelector) {
        return this.apiService.delete(`/transactions/${event.templateId}/${occurrence}`, {
            params: {
                which: eventSelector || this.eventUtil.EventRepeatSelector.OnlyThis
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/application/service/calendar/transaction/event.service.js